import { css, styled } from 'styled-components';

export const StyledTextFieldLabel = styled.label<{ isDisabled?: boolean }>`
  ${({ isDisabled = false, theme }) => css`
    justify-self: flex-start;
    font-size: 0.75rem;
    font-weight: 400;
    line-height: 1.333;
    color: ${isDisabled ? theme.colorsV2.gray40 : theme.colorsV2.gray60};
    margin: 10px 0 0 16px;
  `}
`;

StyledTextFieldLabel.displayName = 'TextField.Label';
